module.exports = __webpack_public_path__ + "img/bot-interview-mobile.d3f982e7.svg";